<div class="row">
        <div class="col-sm-12">
            <div class="container header-background">
                <a href="/"><img src="../../../assets/logo.png" title="Comply by Edulink"/></a>
            </div>
        </div>
</div>
<ui-view name="content"></ui-view>